import { render, staticRenderFns } from "./RepeatersPage.vue?vue&type=template&id=38bca258&scoped=true&"
import script from "./RepeatersPage.vue?vue&type=script&lang=js&"
export * from "./RepeatersPage.vue?vue&type=script&lang=js&"
import style0 from "./RepeatersPage.vue?vue&type=style&index=0&id=38bca258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bca258",
  null
  
)

export default component.exports